import React, { useState } from "react";
import QuestionStep from "./QuestionStep";

export default function InterviewSession({
  data: questions,
  sessionId,
  onSessionComplete,
}) {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  const handleNextQuestion = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
    } else {
      onSessionComplete();
    }
  };

  if (!questions || questions.length === 0) {
    return (
      <p className="text-center dark:text-gray-300">
        No questions available for this session.
      </p>
    );
  }

  const currentQuestion = questions[currentQuestionIndex];

  return (
    <QuestionStep
      question={currentQuestion}
      sessionId={sessionId}
      onComplete={handleNextQuestion}
      questionNumber={currentQuestionIndex + 1}
      totalQuestions={questions.length}
    />
  );
}
